import TextInput from "./Inputs/TextInput";
import SINInput from "./Inputs/SINInput";
import { handleChange, sinValidation } from "../Utils/DataCollectionUtils";
import InputRowGroup from "./Inputs/InputRowGroup";
import InputRow from "./Inputs/InputRow";
import { LANGUAGES, GENDERS, PROVINCES } from "../Utils/PlanUtils";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useAuthenticationStatus } from "../Authentication/AuthenticationStatusProvider";
import BooleanInput from "./Inputs/BooleanInput";
import DropdownInput from "./Inputs/DropdownInput";
import DateInput from "./Inputs/DateInput";
import { Link, useParams } from "react-router-dom";
import { sprintf } from "../Utils/FormattingUtils";

const SubscribersDataCollection = ({ state }) => {
    const params = useParams();
    let { authenticationStatus } = useAuthenticationStatus();
    const [agent, setAgent] = useState({})
    const { t } = useTranslation();
    useEffect(() => {
        if (!authenticationStatus.user) {
            return;
        }
        const agent = authenticationStatus.user.agentCodes.find((ac) => ac.code === state.common.agentCode);
        console.log(agent);
        setAgent(authenticationStatus.user.agentCodes.find((ac) => ac.code === state.common.agentCode));
    }, [authenticationStatus.user, state.common.agentCode]);

    if (state.application.masterApplicationId) {
        return (
            <InputRowGroup
                label={t("Subscriber details must be changed on the Primary enrolment of this Family Enrolment.")}>
                <Link
                    to={'/enrolment/' + state.application.masterApplicationId + '/Subscribers/' + (params.item || '')}>
                    Go to primary enrolment
                </Link>
            </InputRowGroup>
        )
    } else {
        return (
            <form>
                <InputRowGroup>
                    <InputRow label={t("Preferred Language")}>
                        <DropdownInput
                            name={'preferedLanguage'}
                            state={state.common}
                            onChange={handleChange(state.setCommon)}
                            options={[
                                { 'label': t('English'), 'value': true },
                                { 'label': t('French'), 'value': false },
                            ]}
                            booleanValue={true}
                        />
                    </InputRow>

                    <InputRow label={t("Does each subscriber read, speak and understand English or French?")}>
                        <BooleanInput
                            name={"subscriberEngOrFr"}
                            label={t("Yes")}
                            state={state.common}
                            onChange={handleChange(state.setCommon)}
                        />
                    </InputRow>

                    <InputRow
                        label={t("Was the sales presentation conducted, in whole or in part, in a third language?")}>
                        <BooleanInput
                            name={"representativeDetails"}
                            label={t("Yes")}
                            state={state.common}
                            onChange={handleChange(state.setCommon)}
                        />
                    </InputRow>

                    <InputRow label={t("Language used to detail plan")}
                        presetValues={
                            [
                                t("English"),
                                t("French")
                            ]
                        }
                        onPresetSelected={(preset) => {
                            state.setCommon({ ...state.common, representativeDetailsLanguage: preset });
                        }}
                    >
                        <TextInput
                            placeholder={t('Language')}
                            name={'representativeDetailsLanguage'}
                            state={state.common}
                            onChange={handleChange(state.setCommon)}
                        />

                    </InputRow>
                    <InputRow
                        label={t("Is this client refererred to Children's Education Funds Inc. under a referral agreement?")}>
                        <BooleanInput
                            name={"referralAgreement"}
                            label={t("Yes")}
                            state={state.common}
                            onChange={handleChange(state.setCommon)}
                        />
                    </InputRow>
                    {agent && agent.greatwayDRYN &&
                        <InputRow
                            label={t("Is this a Greatway referral?")}>
                            <BooleanInput
                                name={"specialReferralAgreement"}
                                label={t("Yes")}
                                state={state.common}
                                onChange={handleChange(state.setCommon)}
                            />
                        </InputRow>
                    }
                </InputRowGroup>

                <InputRowGroup label={t("Subscriber")}>
                    <InputRow label={t("Name")}>
                        <TextInput
                            placeholder={t('Given Name')}
                            name={'firstName'}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                            autoFocus={params.item === 'subscriber.givenName'}
                            maxLength={50}
                        />

                        <TextInput
                            placeholder={t('Middle Name')}
                            name={'middleName'}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                            autoFocus={params.item === 'subscriber.middleName'}
                            maxLength={30}
                        />

                        <TextInput
                            placeholder={t('Last Name')}
                            name={'lastName'}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                            maxLength={50}
                        />
                    </InputRow>

                    <InputRow label={t("Title")}
                        presetValues={[
                            t('Mr'),
                            t('Mrs'),
                            t('Miss'),
                            t('Ms'),
                            t('Dr')
                        ]}
                        onPresetSelected={(preset) => {
                            state.setSubscriber({ ...state.subscriber, title: preset });
                        }}
                    >
                        <TextInput
                            placeholder={t('Title')}
                            name={'title'}
                            state={state.subscriber}
                            maxLength={5}
                            onChange={handleChange(state.setSubscriber)}
                        />
                    </InputRow>

                    <InputRow label={t("Primary Care Giver")}>
                        <BooleanInput
                            name={"primaryCaregiver"}
                            label={t("Yes")}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                        />
                    </InputRow>

                    <InputRow label={t("Custodial Parent")}>
                        <BooleanInput
                            name={"custodialParent"}
                            label={t("Yes")}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                        />
                    </InputRow>

                    <InputRow label={t("Spouse or Common Law of PCG")}>
                        <BooleanInput
                            name={"pcgSpouse"}
                            label={t("Yes")}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                        />
                    </InputRow>

                    <InputRow label={t("Gender")}>
                        <DropdownInput
                            state={state.subscriber}
                            name={'gender'}
                            onChange={handleChange(state.setSubscriber, false)}
                            options={GENDERS}
                        />
                    </InputRow>

                    <InputRow label={t("Social Insurance Number")}>
                        <SINInput
                            placeholder={t('Social Insurance Number')}
                            name={'sin'}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                            validationCallback={sinValidation}
                            maxLength={10}
                        />
                    </InputRow>

                    <InputRow label={t("Type of Identification")}>
                        <DropdownInput
                            name={'idtype'}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                            options={[
                                { label: t('Select one'), value: '' },
                                { label: t('Drivers License'), value: 'Drivers License' },
                                { label: t('Passport'), value: 'Passport' },
                                { label: t('Other'), value: 'Other' },
                            ]} //TODO: Confirm, we don't need to translate the values?
                        />
                    </InputRow>

                    <InputRow label={t("Identification Number")}>
                        <TextInput
                            placeholder={t('Identification Number')}
                            name={'id'}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                            maxLength={30}
                        />
                    </InputRow>

                    <InputRow label={t('Date of Birth')}>
                        <DateInput
                            name={'birthdate'}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                            maxDate={(new Date()).toISOString().split('T')[0]}
                        />
                    </InputRow>

                    <InputRow label={t('E-Mail Address')}>
                        <TextInput
                            placeholder={t('E-Mail Address')}
                            name={'email'}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                            maxLength={50}
                            validationRules={{
                                pattern: {
                                    value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
                                }
                            }}
                            validationFailedMessage={'The E-Mail address entered was invalid'}
                            autoFocus={params.item === 'subscriber.email'}
                        />
                    </InputRow>

                    <InputRow label={t('Mobile Phone Number')}>
                        +1
                        <TextInput
                            placeholder={t('Mobile Phone Number')}
                            name={'mobilePhone'}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                            maxLength={10}
                            validationRules={{
                                pattern: {
                                    value: /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/
                                }
                            }}
                            autoFocus={params.item === 'subscriber.mobilePhone'}
                            validationFailedMessage={'The phone number entered was invalid'}
                        />
                        <div className={'info'}>
                            {t("As a security precaution, a text message may be sent to this number during the signing process to verify the identity of the subscriber.")}
                        </div>
                    </InputRow>

                    <InputRow label={t("Signing Method")}>
                        <DropdownInput
                            name={'inPersonSigner'}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                            options={[{ label: t('In Person'), value: true }, { label: t('Remote'), value: false }]}
                            booleanValue={true}
                        />
                    </InputRow>

                </InputRowGroup>


                {state.common.subscriber2Include &&
                    <InputRowGroup label={t("Joint Subscriber")}>
                        <InputRow label={t("Name")}>
                            <TextInput
                                placeholder={t('Given Name')}
                                name={'firstName'}
                                state={state.jointSubscriber}
                                maxLength={50}
                                onChange={handleChange(state.setJointSubscriber)}
                                autoFocus={params.item === 'subscriber2.givenName'}
                            />

                            <TextInput
                                placeholder={t('Middle Name')}
                                name={'middleName'}
                                state={state.jointSubscriber}
                                maxLength={30}
                                onChange={handleChange(state.setJointSubscriber)}
                                autoFocus={params.item === 'subscriber2.middleName'}
                            />


                            <TextInput
                                placeholder={t('Last Name')}
                                name={'lastName'}
                                state={state.jointSubscriber}
                                maxLength={50}
                                onChange={handleChange(state.setJointSubscriber)}
                            />
                        </InputRow>

                        <InputRow label={t("Title")}
                            presetValues={[
                                t('Mr'),
                                t('Mrs'),
                                t('Miss'),
                                t('Ms'),
                                t('Dr')
                            ]}
                            onPresetSelected={(preset) => {
                                state.setJointSubscriber({ ...state.jointSubscriber, title: preset });
                            }}
                        >
                            <TextInput
                                placeholder={t('Title')}
                                name={'title'}
                                maxLength={5}
                                state={state.jointSubscriber}
                                onChange={handleChange(state.setJointSubscriber)}
                            />
                        </InputRow>

                        <InputRow label={t("Primary Care Giver")}>
                            <BooleanInput
                                name={"primaryCaregiver"}
                                label={t("Yes")}
                                state={state.jointSubscriber}
                                onChange={handleChange(state.setJointSubscriber)}
                            />
                        </InputRow>

                        <InputRow label={t("Custodial Parent")}>
                            <BooleanInput
                                name={"custodialParent"}
                                label={t("Yes")}
                                state={state.jointSubscriber}
                                onChange={handleChange(state.setJointSubscriber)}
                            />
                        </InputRow>

                        <InputRow label={t("Spouse or Common Law of PCG")}>
                            <BooleanInput
                                name={"pcgSpouse"}
                                label={t("Yes")}
                                state={state.jointSubscriber}
                                onChange={handleChange(state.setJointSubscriber)}
                            />
                        </InputRow>

                        <InputRow label={t("Gender")}>
                            <DropdownInput
                                state={state.jointSubscriber}
                                name={'gender'}
                                onChange={handleChange(state.setJointSubscriber, false)}
                                options={GENDERS}
                            />
                        </InputRow>

                        <InputRow label={t("Social Insurance Number")}>
                            <SINInput
                                placeholder={t('Social Insurance Number')}
                                name={'sin'}
                                state={state.jointSubscriber}
                                maxLength={10}
                                onChange={handleChange(state.setJointSubscriber)}
                                validationCallback={sinValidation}
                            />
                        </InputRow>

                        <InputRow label={t("Type of Identification")}>
                            <DropdownInput
                                name={'idtype'}
                                state={state.jointSubscriber}
                                onChange={handleChange(state.setJointSubscriber)}
                                options={[
                                    { label: t('Select one'), value: '' },
                                    { label: t('Drivers License'), value: 'Drivers License' },
                                    { label: t('Passport'), value: 'Passport' },
                                    { label: t('Other'), value: 'Other' },
                                ]} //TODO: Confirm, we don't need to translate the values?
                            />
                        </InputRow>

                        <InputRow label={t("Identification Number")}>
                            <TextInput
                                placeholder={t('Identification Number')}
                                name={'id'}
                                maxLength={30}
                                state={state.jointSubscriber}
                                onChange={handleChange(state.setJointSubscriber)}
                            />
                        </InputRow>

                        <InputRow label={t('Date of Birth')}>
                            <DateInput
                                name={'birthdate'}
                                state={state.jointSubscriber}
                                onChange={handleChange(state.setJointSubscriber)}
                                maxDate={(new Date()).toISOString().split('T')[0]}
                            />
                        </InputRow>

                        <InputRow label={t('E-Mail Address')}>
                            <TextInput
                                placeholder={t('E-Mail Address')}
                                name={'email'}
                                state={state.jointSubscriber}
                                onChange={handleChange(state.setJointSubscriber)}
                                maxLength={30}
                                validationRules={{
                                    pattern: {
                                        value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
                                    }
                                }}
                                validationFailedMessage={'The E-Mail address entered was invalid'}
                                autoFocus={params.item === 'subscriber2.email'}
                            />
                        </InputRow>

                        <InputRow label={t('Mobile Phone Number')}>
                            +1
                            <TextInput
                                placeholder={t('Mobile Phone Number')}
                                name={'mobilePhone'}
                                state={state.jointSubscriber}
                                maxLength={10}
                                onChange={handleChange(state.setJointSubscriber)}
                                validationRules={{
                                    pattern: {
                                        value: /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/
                                    }
                                }}
                                autoFocus={params.item === 'subscriber2.mobilePhone'}
                                validationFailedMessage={'The phone number entered was invalid'}
                            />
                            <div className={'info'}>
                                {t("As a security precaution, a text message may be sent to this number during the signing process to verify the identity of the joint subscriber.")}
                            </div>
                        </InputRow>


                        <InputRow label={t("Signing Method")}>
                            <DropdownInput
                                name={'inPersonSigner'}
                                state={state.jointSubscriber}
                                onChange={handleChange(state.setJointSubscriber)}
                                options={[{ label: t('In Person'), value: true }, { label: t('Remote'), value: false }]}
                                booleanValue={true}
                            />
                        </InputRow>
                    </InputRowGroup>
                }

                <InputRowGroup label={t("Address")}>
                    <InputRow label={t("Address")}>
                        <TextInput
                            placeholder={t('Number')}
                            name={'streetNumber'}
                            state={state.subscriber}
                            maxLength={6}
                            onChange={handleChange(state.setSubscriber)}
                        />

                        <TextInput
                            placeholder={t('Street')}
                            name={'address'}
                            state={state.subscriber}
                            maxLength={30}
                            onChange={handleChange(state.setSubscriber)}
                        />

                        <TextInput
                            placeholder={t('Suite')}
                            name={'suite'}
                            state={state.subscriber}
                            maxLength={4}
                            onChange={handleChange(state.setSubscriber)}
                        />

                        <TextInput
                            placeholder={t('PO Box')}
                            name={'pobox'}
                            state={state.subscriber}
                            maxLength={6}
                            onChange={handleChange(state.setSubscriber)}
                        />
                    </InputRow>

                    <InputRow label={t("City")}>
                        <TextInput
                            placeholder={t('City')}
                            name={'city'}
                            state={state.subscriber}
                            maxLength={30}
                            onChange={handleChange(state.setSubscriber)}
                        />
                    </InputRow>

                    <InputRow label={t("Province")}>
                        <DropdownInput
                            name={'province'}
                            state={state.subscriber}
                            onChange={handleChange(state.setSubscriber)}
                            options={PROVINCES}
                        />
                    </InputRow>

                    {state.subscriber.province !== state.agent.province &&
                        <InputRow>
                            <div className={'centered-text financial-warning'}>
                                {sprintf(t(`Your DR code %@ is not licensed in the province %@.`), state.agent.code, state.subscriber.province)}
                            </div>
                        </InputRow>
                    }

                    <InputRow label={t("Country")}>
                        <TextInput
                            placeholder={t('Country')}
                            name={'country'}
                            state={state.subscriber}
                            maxLength={20}
                            onChange={handleChange(state.setSubscriber)}
                        />
                    </InputRow>

                    <InputRow label={t("Postal Code")}>
                        <TextInput
                            placeholder={t('Postal Code')}
                            name={'postalCode'}
                            state={state.subscriber}
                            maxLength={7}
                            onChange={handleChange(state.setSubscriber)}
                        />
                    </InputRow>

                    <InputRow label={t("Home Phone")}>
                        <TextInput
                            placeholder={t('Home Telephone')}
                            name={'homePhone'}
                            state={state.subscriber}
                            maxLength={10}
                            onChange={handleChange(state.setSubscriber)}
                            validationRules={{
                                pattern: {
                                    value: /^[\d-]*$/
                                }
                            }}
                            validationFailedMessage={'The phone number entered was invalid'}
                        />
                    </InputRow>

                    <InputRow label={t("Business Phone")}>
                        <TextInput
                            placeholder={t('Business Telephone')}
                            name={'businessPhone'}
                            state={state.subscriber}
                            maxLength={10}
                            onChange={handleChange(state.setSubscriber)}
                            validationRules={{
                                pattern: {
                                    value: /^[\d-]*$/
                                }
                            }}
                            validationFailedMessage={'The phone number entered was invalid'}
                        />
                    </InputRow>

                    {/* <InputRow label={t("AIR MILES Collector Number")}>
                        <TextInput
                            placeholder={t('AIR MILES Collector Number')}
                            name={'airMiles'}
                            state={state.subscriber}
                            maxLength={18}
                            onChange={handleChange(state.setSubscriber)}
                        />
                    </InputRow> */}

                </InputRowGroup>

            </form>
        )
    }
}

export default SubscribersDataCollection;